import { render, staticRenderFns } from "./form-organizations-users-edit.vue?vue&type=template&id=e98c2a72&lang=pug"
import script from "./form-organizations-users-edit.vue?vue&type=script&lang=js"
export * from "./form-organizations-users-edit.vue?vue&type=script&lang=js"
import style0 from "./form-organizations-users-edit.vue?vue&type=style&index=0&id=e98c2a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports